export default __webpack_public_path__ + "static/media/PMS-BG.c11e2b61.svg";